import { Http } from 'packages/workspace/modules/prelude/http';
import { UseMutationResult, useMutation } from 'react-query';

export function useChangePassword(): UseMutationResult<string, unknown, { old_password: string; new_password: string }, unknown> {
  return useMutation(async (password_object: { old_password: string; new_password: string }) => Http.Request<string>('PUT', `/workspaces/api/v1/account-passwords.change`, password_object));
}

export function useResetPassword(): UseMutationResult<string, unknown, { userName: string; session: string; new_password: string; clientId: string }, unknown> {
  return useMutation(async (password_object: { userName: string; code: string; new_password: string; clientId: string }) =>
    Http.Request<string>('PUT', `/workspaces/api/v1/account-passwords.reset`, password_object)
  );
}

export function useForgotPassword(): UseMutationResult<string, unknown, { userName: string; code: string; new_password: string; clientId: string; nameAttribute: string }, unknown> {
  return useMutation(async (password_object: { userName: string; code: string; new_password: string; clientId: string; nameAttribute: string }) =>
    Http.Request<string>('PUT', `/workspaces/api/v1/account-passwords.forgot`, password_object)
  );
}
